import React, { useState, useEffect } from "react";
import { ButtonGroupWrapper } from "./styles";

const ButtonGroup = ({ children }) => {
  return <ButtonGroupWrapper>{children}</ButtonGroupWrapper>;
};

export { ButtonGroup };
